import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'percentage' })
export class PercentagePipe implements PipeTransform {
  transform(val) {
    if (String(val).indexOf('%') === -1) {
      return val ? val + '%' : 0 + '%';
    }
  }
}
